import {
  CampaignConfigDto, DiscountDto,
} from '@coretava/api/ecommerce-service';
import { formatCampaignReward, formatDiscountValue } from '@gamiphy/loyalty-station-desktop/components/cashback/utils';
import { Trans } from '@gamiphy/react-i18n';
import {
  Box,
  Typography,
} from '@mui/material';
import React from 'react';

const Congrats: React.FC<{
  campaign: CampaignConfigDto,
  discount: DiscountDto
}> = ({
  campaign, discount,
}) => {
  const rewardValues = React.useMemo(() => ({
    discountValue: discount ? formatDiscountValue(discount) : formatCampaignReward(campaign),
    minRedemptionAmount: discount?.cashbackConfig.minRedemptionValue ?? 100 * ((campaign.rewardConfig?.value ?? 0) / (campaign.rewardConfig?.multiplier ?? 1)),

  }), [discount, campaign]);

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography fontSize={14} fontWeight={600}>
        <Trans
          i18nKey="campaigns.boosters.referral.widget.congrats"
          defaults="Congratulations! 🎉"
        />
      </Typography>
      <Typography fontSize={14}>
        <Trans
          i18nKey="campaigns.boosters.survey.widget.congrats.reward"
          defaults="You’ve earned a {{reward}} discount. Enjoy your savings on orders over {{minRedemptionValue, currency}}!"
          values={{
            reward: rewardValues.discountValue,
            minRedemptionValue: rewardValues.minRedemptionAmount,
          }}
        />
      </Typography>

      <Typography fontSize={16} fontWeight={600} textTransform="uppercase" color="#ADADAD">
        <Trans
          i18nKey="campaigns.status.completed"
          defaults="Completed"
        />
      </Typography>
    </Box>
  );
};

export default Congrats;
